import IconLock from "app/icons/IconLock";
import PlayAudioButton, {
  type PlayAudioButtonHandle,
} from "app/ui/PlayAudioButton";
import cn from "app/utils/classnames";

interface LockableAudioButtonProps {
  children: React.ReactNode;
  audioUrl: string;
  onClick: () => void;
  onAudioEnd?: () => void;
  isLocked: boolean;
  isDisabled: boolean;
  unlockCost?: number;
  onUnlock?: () => void;
  buttonRef: React.Ref<PlayAudioButtonHandle>;
}

export default function LockableAudioButton(props: LockableAudioButtonProps) {
  return (
    <PlayAudioButton
      className={cn(
        "min-w-28 lg:min-h-13 h-20",
        "flex flex-col gap-1",
        props.isDisabled
          ? "pointer-events-none opacity-50 bg-gray-100"
          : "pointer-events-auto opacity-100",
      )}
      audioUrl={props.audioUrl}
      onClick={() => {
        if (props.isLocked) {
          props.onUnlock?.();
        }
        props.onClick();
      }}
      onAudioEnd={props.onAudioEnd}
      iconSize={28}
      iconOverride={props.isLocked ? <CircleIcon /> : undefined}
      ref={props.buttonRef}
    >
      {props.children}
      <p
        className={cn(
          "w-full",
          "font-sans text-xs",
          "flex justify-center items-center gap-0.5",
          "-mt-1.5",
          props.isLocked ? "opacity-100" : "opacity-35",
        )}
      >
        {props.isLocked ? (
          <span>-{props.unlockCost}x</span>
        ) : (
          <span>Unlocked</span>
        )}
      </p>
    </PlayAudioButton>
  );
}

function CircleIcon() {
  return (
    <div
      className={cn(
        "bg-black rounded-full w-[28px] h-[28px]",
        "flex justify-center items-center",
      )}
    >
      <IconLock className="fill-white" />
    </div>
  );
}
